import _ from "lodash";
import moment from "moment";
import { getListIndemnify } from "../../../../../apis/claimPBAApi";
import * as PATH from "../../../../../configs/routesConfig";
import { MAXIMUN_LINE_EXPORT_EXCEL_PBA } from "../../../../../utils/contains";

export default function pbaReducer({
  state,
  dispatch,
  action,
  form,
  roleType,
  history,
  dataSearchPBAList,
  setDataSearchPBAList,
}) {
  const cases = {
    initial: async () => {
      const res = {};
      dispatch("onLoading");

      const params = _.isEmpty(dataSearchPBAList)
        ? {
            insuredPhone: "",
            insuredPrivateId: null,
            code: null,
            statusId: null,
            from: moment().subtract(7, "days").toDate(),
            to: moment().toDate(),
            limit: 10,
            offset: 0,
            productIdParent: 15,
          }
        : {
            ...dataSearchPBAList,
            limit: 10,
            offset: 0,
            productIdParent: 15,
          };

      const dataApi = await getListIndemnify(roleType, params);

      if (dataApi instanceof Error) {
        return { loading: false };
      }

      if (dataApi?.data?.statusCode === 200) {
        res.rows = _.get(dataApi, "data.result.data") || [];
        res.totalRows = _.get(dataApi, "data.result.total") || 0;
        res.pageTable = {
          count: Math.ceil(dataApi.data.result.total / 10),
          page: 0,
        };
        res.dataSearch = _.isEmpty(dataSearchPBAList)
          ? {
              from: moment().subtract(7, "days"),
              to: moment().toDate(),
            }
          : { ...dataSearchPBAList };
      }

      return { ...res, loading: false };
    },

    onChangeSearch: () => {
      const { name, value } = action;
      const { dataSearch } = state;
      dataSearch[name] = value;

      return { dataSearch };
    },

    changePage: async () => {
      const {
        data: { item },
      } = action;

      form === "report-claim" &&
        history.push(`${PATH.DETAIL_REPORT_PBA}?id=${item.id}`);

      form === "review-claim" &&
        history.push(`${PATH.DETAIL_REVIEW_PBA}?id=${item.id}`);

      // form === "report-claim" &&
      //   history.push(`${PATH.DETAIL_REPORT_PBA}/pba?id=${item.id}`);

      // form === "review-claim" &&
      //   history.push(`${PATH.DETAIL_REVIEW_PBA}/pba?id=${item.id}`);
    },

    onPaging: async () => {
      const { page, rowsPerPage } = action;
      const { dataSearch } = state;

      dispatch("onLoading");

      const params = {
        insuredPhone: dataSearch?.insuredPhone || "",
        insuredPrivateId: dataSearch?.insuredPrivateId || null,
        code: dataSearch?.code || null,
        statusId: dataSearch?.statusId || null,
        from: dataSearch?.from || null,
        to: dataSearch?.to || null,
        limit: rowsPerPage,
        offset: page * rowsPerPage,
        productIdParent: 15,
      };

      const dataApi = await getListIndemnify(roleType, params);

      const res = {};

      if (dataApi instanceof Error) {
        return { loading: false };
      }

      if (dataApi?.data?.statusCode === 200) {
        res.rows = _.get(dataApi, "data.result.data") || [];
        res.totalRows = _.get(dataApi, "data.result.total") || 0;
        res.pageTable = {
          count: Math.ceil(dataApi.data.result.total / (rowsPerPage || 10)),
          page: page,
          rowsPerPage: rowsPerPage,
        };
      }

      return { ...res, loading: false };
    },

    onSubmitSearch: async () => {
      const { dataSearch, pageTable } = state;
      setDataSearchPBAList({ ...dataSearch });
      dispatch("onLoading");

      const params = {
        insuredPhone: dataSearch?.insuredPhone || "",
        insuredPrivateId: dataSearch?.insuredPrivateId || null,
        code: dataSearch?.code || null,
        statusId: dataSearch?.statusId || null,
        from: dataSearch?.from || null,
        to: dataSearch?.to || null,
        limit: pageTable?.rowsPerPage || 10,
        offset: 0,
        productIdParent: 15,
      };

      const dataApi = await getListIndemnify(roleType, params);

      const res = {};

      if (dataApi instanceof Error) {
        return { loading: false };
      }

      if (dataApi?.data?.statusCode === 200) {
        res.rows = _.get(dataApi, "data.result.data") || [];
        res.totalRows = _.get(dataApi, "data.result.total") || 0;
        res.pageTable = {
          count: Math.ceil(
            dataApi.data.result.total / (pageTable?.rowsPerPage || 10)
          ),
          page: 0,
          rowsPerPage: pageTable?.rowsPerPage,
        };
      }

      return { ...res, loading: false };
    },

    onLoading: () => ({ loading: true }),

    onSubmitExport: () => {
      const { totalRows } = state;

      if (totalRows > +MAXIMUN_LINE_EXPORT_EXCEL_PBA) {
        return { openMaxLineDialog: true };
      } else {
        dispatch("getListExport");
      }
    },

    getListExport: async () => {
      const { count, dataSearch } = state;
      const res = {};
      dispatch("onLoading");

      const params = {
        insuredPhone: dataSearch?.insuredPhone || "",
        insuredPrivateId: dataSearch?.insuredPrivateId || null,
        code: dataSearch?.code || null,
        statusId: dataSearch?.statusId || null,
        from: dataSearch?.from || null,
        to: dataSearch?.to || null,
        limit: +MAXIMUN_LINE_EXPORT_EXCEL_PBA,
        offset: 0,
        productIdParent: 15,
      };

      const dataApi = await getListIndemnify(roleType, params);

      if (dataApi instanceof Error) {
        return { loading: false };
      }

      if (dataApi?.data?.statusCode === 200) {
        res.count = +count + 1;
        res.dataExport = _.get(dataApi, "data.result.data") || [];
      }

      return { ...res, loading: false, openMaxLineDialog: false };
    },

    closeMaxLineDialog: () => ({ openMaxLineDialog: false }),

    //
  };

  return action?.type && cases[action?.type];
}
